/**
 * Field definitions for the Verifine product sheet.
 * Order matters — it drives both the admin form and the public bottle page.
 */
const CONDITION_OPTIONS = [
  "Excellent", "Very Good", "Good", "Average",
  "Below Average", "Poor", "Very Poor", "Missing",
];

const BOTTLE_CAPACITY_OPTIONS = [
  "375 ml", "500 ml", "750 ml", "1.5 L", "3 L", "4.5 L",
  "5 L", "6 L", "9 L", "12 L",
];

const FILL_LEVEL_OPTIONS = [
  "In Neck", "Base Neck", "Very Top Shoulder", "Top Shoulder",
  "High Shoulder", "High to Mid-Shoulder", "Mid-Shoulder",
  "Low Shoulder", "Below Low Shoulder",
  "Less than 1 cm", "1 cm", "1.5 cm", "2 cm", "2.5 cm", "3 cm",
  "3.5 cm", "4 cm", "4.5 cm", "5 cm", "5.5 cm", "6 cm", "More than 6 cm",
];

export const PRODUCT_SHEET_FIELDS = [
  { key: "certificate_id", label: "Certificate ID", required: true },
  { key: "bottle_id", label: "Bottle ID", required: true },
  { key: "hologram", label: "Hologram", required: true },
  { key: "vintage", label: "Vintage", required: true },
  { key: "bottle_capacity", label: "Bottle (Cap.)", required: true, options: BOTTLE_CAPACITY_OPTIONS },
  { key: "wine_name", label: "Wine Name", required: true },
  { key: "producer", label: "Producer", required: true },
  { key: "region_origin", label: "Region / Origin", required: false },
  { key: "serial_number", label: "Serial Number", required: false },
  { key: "fill_level", label: "Fill Level", required: true, options: FILL_LEVEL_OPTIONS },
  { key: "label_condition", label: "Label Condition", required: true, options: CONDITION_OPTIONS },
  { key: "capsule_condition", label: "Capsule Condition", required: true, options: CONDITION_OPTIONS },
  { key: "stated_abv", label: "Stated ABV%", required: false },
  { key: "antifraud", label: "Antifraud", required: false },
  { key: "other", label: "Other", required: false, multiline: true },
];

export const REQUIRED_KEYS = PRODUCT_SHEET_FIELDS.filter((f) => f.required).map((f) => f.key);

export const EMPTY_SHEET = PRODUCT_SHEET_FIELDS.reduce((acc, f) => {
  acc[f.key] = "";
  return acc;
}, {});
